module.exports = __webpack_public_path__ + "img/remix-06.6dd93617.png";